import apiClient from "./axios"

export const getEmployeeDesignations = async (params = {}) => {
  const { data } = await apiClient.get("/employee-designations", { params })
  return data
}

export const getEmployeeDesignation = async id => {
  const { data } = await apiClient.get(`/employee-designations/${id}`)
  return data
}

export const createEmployeeDesignation = async designationData => {
  const { data } = await apiClient.post("/employee-designations", designationData)
  return data
}

export const editEmployeeDesignation = async ({ id, ...designationData }) => {
  const { data } = await apiClient.patch(`/employee-designations/${id}`, designationData)
  return data
}

export const deleteEmployeeDesignation = async id => {
  const { data } = await apiClient.delete(`/employee-designations/${id}`)
  return data
}

export const getAllEmployeeDesignations = async (params = {}) => {
  const { data } = await apiClient.get("/employee-designations", {
    params: { ...params, all: true },
  })
  return data
}

export const getTrashedEmployeeDesignations = async (params = {}) => {
  const { data } = await apiClient.get("/employee-designations/trashed", { params })
  return data
}

export const restoreEmployeeDesignation = async id => {
  const { data } = await apiClient.post(`/employee-designations/${id}/restore`)
  return data
}
